(function() {
  'use strict';

  var valorDeclarado = {
    bindings: {
      oldValue: '<',
      options: '<',
      referenceValue: '<',
      newValue: '&',
      index: '<',
      formName: '<'
    },
    template: [
      '<div class="input-d-block" data-ng-class="{\'has-error\': $ctrl.formName.input_{{$ctrl.index}}.$error.maxLimit || !$ctrl.referenceValue.codigoMandae}">',
      '<input type="text" data-ng-model="$ctrl.oldValue" name="input_{{$ctrl.index}}" class="form-control" data-ng-blur="$ctrl.saveVD()" data-ng-change="$ctrl.changeVD($ctrl.referenceValue)" placeholder="Ex: R$25,00" ui-money-mask maxlength="{{ $ctrl.getMaxlength() }}" popover="Valor máximo {{ $ctrl.mathVDMax($ctrl.referenceValue.codigoMandae) | finance:true }}" popover-trigger="focus" popover-append-to-body="true" popover-placement="top" data-ng-disabled="!$ctrl.getMaxlength()" max-limit="{{$ctrl.mathVDMax($ctrl.referenceValue.codigoMandae)}}" />',
      '<span>',
      '<label class="additional-charge" data-ng-hide="$ctrl.formName.input_{{$ctrl.index}}.$error.maxLimit || !$ctrl.referenceValue.codigoMandae">Custo adicional: {{ $ctrl.vdAdded($ctrl.referenceValue.codigoMandae, $ctrl.oldValue) | finance:true }}</label>',
      '<label class="help-block" data-ng-show="$ctrl.formName.input_{{$ctrl.index}}.$error.maxLimit && $ctrl.referenceValue.codigoMandae">Limite máximo excedido.</label>',
      '<label class="help-block" data-ng-show="!$ctrl.referenceValue.codigoMandae">Por favor escolha um serviço de envio.</label>',
      '</span>',
      '</div>'
    ].join(''),
    controller: [function() {

      var $ctrl = this;

      $ctrl.$onInit = function() {
        $ctrl.optionsReference = $ctrl.options;
      };

      $ctrl.getMaxlength = function() {
        var value = getVal($ctrl.referenceValue.codigoMandae, 'valorDeclaradoMaximo');
        return _.isNumber(value) ? value.toString().length + 7 : null;
      }

      function getVal(shippingCode, prop) {
        return _.result(_.find($ctrl.optionsReference, function(chr) {
          return chr.servicoEnvio == shippingCode;
        }), prop);
      }

      function mathVD(shippingCode, vd) {
        var percent = getVal(shippingCode, 'percentualValorDeclarado');
        var minVDSended = getVal(shippingCode, 'valorDeclaradoMinimo');
        var costVD = (percent / 100) * (minVDSended >= 0 ? vd - minVDSended : 0);
        return costVD > 0 ? costVD : 0;
      }

      $ctrl.vdAdded = function(shippingCode, vd) {
        return mathVD(shippingCode, vd);
      }

      $ctrl.mathVDMax = function(shippingCode) {
        return getVal(shippingCode, 'valorDeclaradoMaximo');
      };

      $ctrl.changeVD = function(referenceValue) {

        var maxVDSended = getVal(_.get(referenceValue, 'codigoMandae', undefined), 'valorDeclaradoMaximo');

        if (_.isNumber(maxVDSended) && _.isNumber($ctrl.oldValue)) {

          $ctrl.oldValue <= maxVDSended ? $ctrl.vdAdded(referenceValue.codigoMandae, $ctrl.oldValue) : $ctrl.vdAdded(referenceValue.codigoMandae, maxVDSended);

        }

      };

      $ctrl.saveVD = function() {
        $ctrl.newValue({ valueVD: $ctrl.oldValue });
      };

    }]
  };

  angular
    .module('mandaeApp')
    .component('valorDeclarado', valorDeclarado);
}());
